module.exports = __webpack_public_path__ + "media/apps/gif-ios-34-firstframe-8c13a6a0.jpg";